module.exports = __webpack_public_path__ + "static/media/jwt.d0bfa064.svg";